import React from 'react'
import classNames from 'classnames'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Image } from '@/atoms/Image'
import { Modal } from '@/molecules/Modal'
import { PromoImage } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext/types'

interface Props {
  open: boolean
  onClose: () => void
  desktopImage: PromoImage
  mobileImage: PromoImage
  alt: string
  className?: string
  backgroundIsDark?: boolean
}

const MOBILE_WIDTH = 320
const DESKTOP_WIDTH = 420

export const CustomImageModal: React.FC<Props> = ({
  desktopImage,
  mobileImage,
  alt,
  open,
  onClose,
  backgroundIsDark = false,
}) => {
  const mobileHeight = (mobileImage.height / mobileImage.width) * MOBILE_WIDTH
  const desktopHeight = (desktopImage.height / desktopImage.width) * DESKTOP_WIDTH

  return (
    <Modal
      backgroundScreenColor="black"
      isOpen={open}
      onClose={onClose}
      backgroundOverlayClassName="!bg-black/85"
      panelClasses={`bg-bottom bg-cover text-white shadow-dark-4 rounded-3xl !p-0 relative text-center !overflow-visible !bg-transparent`}
      transition="appear"
      className="z-[99999]"
    >
      <div className="relative mx-auto w-[320px] cursor-pointer md:w-[420px]" onClick={onClose}>
        <div className="mx-auto w-[320px] md:hidden">
          <Image
            className="h-full w-full rounded-3xl"
            src={mobileImage.url}
            alt={alt}
            width={MOBILE_WIDTH}
            height={mobileHeight}
            quality={75}
          />
        </div>

        <div className="relative hidden md:block">
          <Image
            className="h-full w-full rounded-3xl"
            src={desktopImage.url}
            alt={alt}
            width={DESKTOP_WIDTH}
            height={desktopHeight}
            quality={75}
          />
        </div>

        <div
          className={classNames(
            'absolute right-2 top-2 md:right-3 md:top-3 cursor-pointer rounded-full p-2',
            backgroundIsDark ? 'bg-white/10' : 'bg-black/10',
          )}
          onClick={onClose}
        >
          <CloseIcon color={backgroundIsDark ? 'white' : 'black'} size={18} />
        </div>
      </div>
    </Modal>
  )
}

export default CustomImageModal
